import PageScroller from "./PageScroller";

export default PageScroller;
